import useInquiry from "@root/hooks/useInquiry";
import React, { createContext, useContext} from "react";

const defaultState: any = {};

const InquiryContext = createContext<any>(defaultState);


export const InquiryContextProvider: React.FC<InquiryProviderProps> = ({
  children,
}) => {
  const data = useInquiry ();
  return (
    <InquiryContext.Provider value={data}>{children}</InquiryContext.Provider>
  );
};

export const useInquiryContext = () => {
  return useContext(InquiryContext);
};
